import $ from 'jquery'
import jQuery from 'jquery';
import 'slick-carousel'
import { getHTMLData} from './../lib/lib'

class HeroNavCarousel {
  constructor(obj) {
    const { element, slides, onChange } = obj;

      if (!element || !slides) return

      this.elem = jQuery(element);
      this.slides = slides
      this.autoplaySpeed = getHTMLData(this.elem, 'autoplay-speed', 4000)
      this.onChange = onChange

      if( this.slides.length > 1) {
        this._generateNavItems()
      }
     
      setTimeout(()=>{
        this._iniCarousel()

      },100)
     
  } 

  _generateNavItems() {
       
    this.slides.each((i, elem) => {
        const titleElem = $(elem).find(".s-hero-carousel__title")
        const text = titleElem.text().trim()
        const navItem = `<div class="s-hero-carousel__nav__item">  
                <div class="s-hero-carousel__nav__item__title">${text}</div>
            </div>`

        $(navItem).appendTo(this.elem)
    })

    this.navItems = $('.s-hero-carousel__nav__item', this.elem)

  }


  _iniCarousel() {
    const self = this  

    this.elem.slick({     
      rows: 0,
      slidesToShow: 2,
      slidesToScroll: 1,
      // center: true,
      autoplay: false,
      vertical:true,   
      dots: false,
      arrows: false,
      infinite: true,
      edgeFriction: 0
    })

    $('.s-hero-carousel__nav__item', this.elem).on("click", (e) => {

      const indx = $(e.target).closest('.s-hero-carousel__nav__item').data('slick-index')
  

      // self.goToSlide($(this))
      if (typeof this.onChange === 'function') this.onChange(indx);
    })
   
  }

  setActiveNavItem(current) {
    if(this.navItems){
      this.navItems.removeClass("active")
      this.navItems.eq(current).addClass("active")
      
      this.elem.slick("slickGoTo", current)  
    }
  
    // const scroll = this.navItems.eq(currentSlide).position().left + this.navCont.scrollLeft()
    // this.navCont.stop().animate({ scrollLeft: scroll }, 300)
  }
  
 
}

export default HeroNavCarousel

